import * as React from 'react'
import Layout from '.././components/layout'
import Employee from '.././components/employee'
import AdayIn from '.././components/aDayin'
import TuitionRates from '.././components/tuitionRates'
import ProgramSlider from '.././components/programSlider'
import JSONDat from ".././data/adayin/young-toddler.json"
import { StaticImage } from 'gatsby-plugin-image'
import { introImage } from '.././components/styles/page.module.scss'
import { employeesWrap } from '.././components/styles/employee.module.scss'
import Slider from "react-slick";
import { Helmet } from 'react-helmet';
import youngToddler1 from '.././images/programs/young-toddler/young-toddler1.jpg';
import youngToddler2 from '.././images/programs/young-toddler/young-toddler2.jpg';
import youngToddler3 from '.././images/programs/young-toddler/young-toddler3.jpg';
import youngToddler4 from '.././images/programs/young-toddler/young-toddler4.jpg';
import youngToddler5 from '.././images/programs/young-toddler/young-toddler5.jpg';
import youngToddler6 from '.././images/programs/young-toddler/young-toddler6.jpg';
import youngToddler7 from '.././images/programs/young-toddler/young-toddler7.jpg';
import youngToddler8 from '.././images/programs/young-toddler/young-toddler8.jpg';
import youngToddler9 from '.././images/programs/young-toddler/young-toddler9.jpg';
import youngToddler10 from '.././images/programs/young-toddler/young-toddler10.jpg';
import youngToddler11 from '.././images/programs/young-toddler/young-toddler11.jpg';
import youngToddler12 from '.././images/programs/young-toddler/young-toddler12.jpg';
import youngToddler13 from '.././images/programs/young-toddler/young-toddler13.jpg';
import youngToddler14 from '.././images/programs/young-toddler/young-toddler14.jpg';
import { sliderImg } from '.././components/styles/layout.module.scss'


const YTPage = () => {
  const pageTitle = "Young Toddler";
  const metaDesc = "Young toddler child care in Santa Maria for children ages 18 months to 2 1/2 years. Columbia Children's Center provides nurturing early learning, play-based exploration, and individualized support.";
  const ageRange = "18 months to 2½ years";
  const faqSchema = {
    '@type': 'FAQPage',
    '@id': 'https://columbiachildrenscenter.com/young-toddler/#faq',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'What age does the Young Toddler program start?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Our Young Toddler program serves children from 18 months to 30 months.',
        },
      },
      {
        '@type': 'Question',
        name: 'What is the teacher-to-child ratio in the Young Toddler classroom?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Our teacher-to-child ratio is 1:6, which helps us provide close support and individual attention.',
        },
      },
      {
        '@type': 'Question',
        name: 'How do toddlers learn in this program?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Toddlers learn through play-based exploration, communication practice, social interaction, and age-appropriate activities designed to support confidence, curiosity, and early development.',
        },
      },
    ],
  };

  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <Layout 
      pageTitle={pageTitle} 
      metaDesc={metaDesc}
      titleOverride="Young Toddler Child Care in Santa Maria, CA | Columbia Children's Center"
      pathname="/young-toddler/"
      schemaData={[faqSchema]}
    >
      <Helmet>
          <link
          rel="stylesheet"
          type="text/css"
          charset="UTF-8"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
        />
      </Helmet>
        <StaticImage 
          src=".././images/home/young-toddler.jpg" 
          width={500} 
          className={introImage}
          alt="Young toddler program at Columbia Children's Center in Santa Maria"
        />
        <h2 id="age"  style={{marginTop: "0"}}>{ageRange}</h2>
        <a href="https://app.tryplayground.com/X7tvoDUHwazFjm1hgbal/book/j2qKHKe4akbD4Cv9DED7" target="_blank" rel="noopener noreferrer" style={{ display: 'inline-block', marginBottom: '1rem', padding: '0.75rem 1.5rem', backgroundColor: '#007bff', color: '#fff', textDecoration: 'none', borderRadius: '0.375rem', fontWeight: 'bold' }}>Book a Tour</a>
        
        <p>Our young toddler program in Santa Maria serves children between the ages of 18 months and 30 months. Our teacher to child ratio is 1:6 so each child receives individual attention and support in a safe, nurturing setting.</p>
        
        <p>To ensure that each child receives the attention they need, we keep our group size at a maximum of 12 children. Our structured, yet flexible approach, allows children to thrive and reach their full potential.</p>
        
        <p>Our Young Toddler classroom is designed to be both stimulating and age-appropriate, with a variety of activities and toys that encourage exploration and learning. Children are encouraged to communicate their wants and needs. We focus on creating learning and social experiences through play.</p>
        
        <p>We believe that play-based learning is the best way for young children to learn and we strive to provide an environment that is both fun and educational. Our experienced staff is dedicated to providing the best care and education for your child.</p>

        {/* <ProgramSlider programImages="young-toddler" /> */}
        <AdayIn pageTitle={pageTitle} >
          <div>
            <ul>
              {JSONDat.days.map((data, index) => (
                <li key={index}>
                  <strong>{data.time}</strong> {data.day}
                </li>  
              ))} 
            </ul>
          </div> 
        </AdayIn>

        <Slider {...settings}>
          <img className={sliderImg} src={youngToddler1} alt="Young Toddler" />
          <img className={sliderImg} src={youngToddler2} alt="Young Toddler" />
          <img className={sliderImg} src={youngToddler3} alt="Young Toddler" />
          <img className={sliderImg} src={youngToddler4} alt="Young Toddler" />
          <img className={sliderImg} src={youngToddler5} alt="Young Toddler" />
          <img className={sliderImg} src={youngToddler6} alt="Young Toddler" />
          <img className={sliderImg} src={youngToddler7} alt="Young Toddler" />
          <img className={sliderImg} src={youngToddler8} alt="Young Toddler" />
          <img className={sliderImg} src={youngToddler9} alt="Young Toddler" />
          <img className={sliderImg} src={youngToddler10} alt="Young Toddler" />
          <img className={sliderImg} src={youngToddler11} alt="Young Toddler" />
          <img className={sliderImg} src={youngToddler12} alt="Young Toddler" />
          <img className={sliderImg} src={youngToddler13} alt="Young Toddler" />
          <img className={sliderImg} src={youngToddler14} alt="Young Toddler" />
        </Slider>        

        <TuitionRates 
          pageTitle={pageTitle} 
          fullDayFive="$385" 
          fullDayFour="$325" 
          fullDayThree="$280" 
          fullDayTwo="$225"
        >
          Single extra days may be arranged with the director at a rate of: $115.
        </TuitionRates>
        <h2>Young Toddler FAQs</h2>
        <h3>What age does the Young Toddler program start?</h3>
        <p>Our Young Toddler program serves children from 18 months to 30 months.</p>
        <h3>What is the teacher-to-child ratio in the Young Toddler classroom?</h3>
        <p>Our teacher-to-child ratio is 1:6, which helps us provide close support and individual attention.</p>
        <h3>How do toddlers learn in this program?</h3>
        <p>Toddlers learn through play-based exploration, communication practice, social interaction, and age-appropriate activities designed to support confidence, curiosity, and early development.</p>
        <div className={employeesWrap}>
          <Employee 
            employeeName="Cynthia Hernandez" 
            employeeTitle="Young Toddler Teacher" 
            employeeImg="Cynthia"
          />
        </div>
    </Layout>
  )
}


export default YTPage
